<template>
  <div class="container-fluid h-100">
    <div class="container">
      <div class="row mt-5 pt-3">
        <div class="col-8 col-md-4 mt-2">
          <input
            v-model="searchN"
            type="text"
            class="form-control"
            id="exampleFormControlInput1"
            placeholder="Buscar usuarios por cédula o por correo"
            autocomplete="off"
            v-on:focus="clearInput"
          />
        </div>
        <div class="col-2 col-md-1 mt-2">
          <button
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            title="Buscar lubricador"
            class="btn btn-danger btn-block"
            @click="search()"
          >
            <i class="fa fa-search m-0 p-0" aria-hidden="true"></i>
          </button>
        </div>
        <div class="col-2 col-md-1 mt-2">
          <button
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            title="Actualizar masivos"
            class="btn btn-success btn-block"
            @click="modalM()"
          >
            <i class="fa fa-upload m-0 p-0" aria-hidden="true"></i>
          </button>
        </div>
        <!-- <div class="col-1 mt-2">
          <button
            data-bs-toggle="tooltip"
            data-bs-placement="bottom"
            title="Reportes de actualización"
            class="btn btn-info btn-block"
            @click="irR()"
          >
            <i class="fa fa-bars m-0 p-0" aria-hidden="true"></i>
          </button>
        </div> -->

        <div class="col-12 col-md-3 mt-2">
          <button
            title="Consultar ingreso de códigos"
            class="btn btn-info btn-block"
            @click="GoCodesStatus()"
          >
            Consultar ingreso de códigos
          </button>
        </div>
        <div class="col-12 col-md-3 mt-2">
          <button
            title="Consultar ingreso de códigos"
            class="btn btn-info btn-block"
            @click="GoHistoryPoints()"
          >
            Consultar puntos obtenidos
          </button>
        </div>

      </div>

      <template v-if="loading.history">
        <div class="d-flex justify-content-center">
          <div
            class="spinner-border text-danger m-3"
            style="width: 4em; height: 4rem"
            role="status"
          ></div>
        </div>
      </template>

      <!-- PAGINACION -->
      <div class="row mt-4">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-striped table-sm">
              <caption class="visually-hidden">Listado de Métricas</caption>
              <thead>
                <tr>
                  <th scope="col" style="text-align: left">Nombres</th>
                  <th scope="col" style="text-align: left">Cédula</th>
                  <th scope="col" style="text-align: left">Correo</th>
                  <th scope="col" style="text-align: left">Direccion</th>
                  <th scope="col" style="text-align: left">Número de teléfono</th>
                  <th scope="col" style="text-align: left">Ciudad</th>
                  <th scope="col" style="text-align: left">Rol</th>
                  <th scope="col" style="text-align: left">Status</th>
                  <th scope="col" style="text-align: left">Acción</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in items" :key="'d' + `item-${i}`">
                  <td style="text-align: left">
                    {{ item.name }} {{ item.last_name }}
                  </td>
                  <td style="text-align: left">
                    {{ item.document_number }}
                  </td>
                  <td style="text-align: left">
                    {{ item.email }}
                  </td>
                  <td style="text-align: left">
                    {{ item.address }}
                  </td>
                  <td style="text-align: left">
                    {{ item.phone }}
                  </td>
                  <td style="text-align: left">
                    <template v-if="item.city != null">
                      {{ item.city.name }}
                    </template>
                  </td>
                  <td style="text-align: left">
                    <template v-if="item.role != null">
                      {{ item.role.name }}
                    </template>
                  </td>
                  <td style="text-align: left">
                    <template v-if="item.status != null">
                      {{ item.status.name }}
                    </template>
                  </td>
                  <td style="text-align: left">
                    <div class="btn-group" role="group">
                      <div class="btn-group" role="group">
                        <button
                          class="
                            btn btn-info
                            mt-0
                            pt-0
                            mb-0
                            pb-0
                            ml-2
                            pl-2
                            mr-2
                            pr-2
                          "
                          title="Editar"
                          @click="update(item)"
                        >
                          <i
                            class="fa fa-pencil m-0 p-0"
                            aria-hidden="true"
                          ></i>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row">
        <div
          class="col-12 col-md-3 col-lg-3 col-xl-3 col-sm-12 mt-2"
          style="text-align: initial"
        >
          <label class="text-p mt-2">
            Página {{ currentPage }} de {{ totalPages }}
            <strong class="text-danger"> | </strong> total: {{ totaItems }}
          </label>
        </div>
        <div class="col-12 col-md-9 col-lg-9 col-xl-9 col-sm-12 mt-2">
          <div class="float-right">
            <v-pagination
              total-visible="2"
              v-model="currentPage"
              :page-count="totalPages"
              :classes="bootstrapPaginationClasses"
            ></v-pagination>
          </div>
        </div>
      </div>

      <!-- END PAGINACION -->
      
    </div>

    <!-- Modal Editar Usuario -->
    <div
      class="modal fade"
      id="modalUpdateL"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content modal-question">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161"><strong>Editar Usuario</strong></label
                ><br />
              </div>

              <div class="col-12 m-0 p-0">
                <div class="row" style="text-align: left">
                  <div class="col-12 m-0 p-0">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            for="state"
                            style="color: #616161; font-size: 14px"
                            ><strong>Nombre *</strong>
                          </label>
                          <input
                            :class="{ 'is-danger': errors.name }"
                            type="text"
                            v-model="form.name"
                            class="form-control"
                          />
                        </div>
                        <span
                          v-if="errors.name"
                          class="text-danger float-left small error-danger mb-2"
                          >{{ errors.name }}</span
                        >
                      </div>
                      <div class="col-12">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            for="state"
                            style="color: #616161; font-size: 14px"
                            ><strong>Apellidos</strong>
                          </label>
                          <input
                            :class="{ 'is-danger': errors.last_name }"
                            type="text"
                            v-model="form.last_name"
                            class="form-control"
                          />
                        </div>
                        <span
                          v-if="errors.last_name"
                          class="text-danger float-left small error-danger mb-2"
                          >{{ errors.last_name }}</span
                        >
                      </div>
                      <div class="col-12 mt-2">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            style="color: #616161; font-size: 14px"
                            ><strong>Correo *</strong>
                          </label>
                          <input
                            :class="{ 'is-danger': errors.email }"
                            type="text"
                            v-model="form.email"
                            class="form-control"
                          />
                        </div>
                        <span
                          v-if="errors.email"
                          class="text-danger float-left small error-danger mb-2"
                          >{{ errors.email }}</span
                        >
                      </div>
                      <div class="col-12 mt-2">
                        <label
                          class="ml-1"
                          style="color: #616161; font-size: 14px"
                          ><strong>Tipo de documento *</strong>
                        </label>
                        <div class="input-group mb-3">
                          <select
                            v-model="form.document_type_id"
                            class="form-control"
                            :class="{ 'is-danger': errors.document_type_id }"
                            id="exampleFormControlSelect1"
                            placeholder="Tipo de documento *"
                          >
                            <option value="0" disabled selected>
                              Seleccionar *
                            </option>
                            <option
                              v-for="(item, i) in listTypeDocuments"
                              :key="'td' + i"
                              :value="item.id"
                            >
                              {{ item.name }}
                            </option>
                          </select>
                        </div>
                        <span
                          v-if="errors.document_type_id"
                          class="text-danger float-left small error-danger"
                          >{{ errors.document_type_id }}</span
                        >
                      </div>
                      <div class="col-12 mt-2">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            style="color: #616161; font-size: 14px"
                            ><strong>Número de documento *</strong>
                          </label>
                          <input
                            :class="{ 'is-danger': errors.document_number }"
                            type="text"
                            v-model="form.document_number"
                            class="form-control"
                          />
                        </div>
                        <span
                          v-if="errors.document_number"
                          class="text-danger float-left small error-danger mb-2"
                          >{{ errors.document_number }}</span
                        >
                      </div>
                      <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                        <div class="form-group" style="text-align: left">
                          <label
                            class="ml-1"
                            style="color: #616161; font-size: 14px"
                            ><strong>Departamento *</strong>
                          </label>

                          <div class="input-group mb-3">
                            <select
                              v-model="form.state_id"
                              class="form-control"
                              :class="{ 'is-danger': errors.state_id }"
                              id="exampleFormControlSelect1"
                            >
                              <option disabled value="0" selected>
                                Departamento
                              </option>
                              <option
                                v-for="(item, i) in listDocuments"
                                :value="item.id"
                                :key="'st' + i"
                              >
                                {{ item.name }}
                              </option>
                            </select>
                          </div>
                          <span
                            v-if="errors.state_id"
                            class="text-danger float-left small error-danger"
                            >{{ errors.state_id }}</span
                          >
                        </div>
                      </div>
                      <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
                        <div class="form-group" style="text-align: left">
                          <label
                            class="ml-1"
                            style="color: #616161; font-size: 14px"
                            ><strong>Ciudad *</strong>
                          </label>

                          <div class="input-group mb-3">
                            <select
                              v-model="form.city_id"
                              class="form-control"
                              :class="{ 'is-danger': errors.city_id }"
                              id="exampleFormControlSelect1"
                            >
                              <option value="0" disabled selected>
                                Ciudad *
                              </option>
                              <option
                                v-for="(item, i) in listCities"
                                :key="'ci' + i"
                                :value="item.id"
                              >
                                {{ item.name }}
                              </option>
                            </select>
                          </div>
                          <span
                            v-if="errors.city_id"
                            class="text-danger float-left small error-danger"
                            >{{ errors.city_id }}</span
                          >
                        </div>
                      </div>
                      <div class="col-12 mt-2">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            for="state"
                            style="color: #616161; font-size: 14px"
                            ><strong>Direccion *</strong>
                          </label>
                          <input
                            :class="{ 'is-danger': errors.address }"
                            type="text"
                            v-model="form.address"
                            class="form-control"
                          />
                        </div>
                        <span
                          v-if="errors.address"
                          class="text-danger float-left small error-danger mb-2"
                          >{{ errors.address }}</span
                        >
                      </div>
                      <div class="col-12 mt-2">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            for="state"
                            style="color: #616161; font-size: 14px"
                            ><strong>Número de teléfono</strong>
                          </label>
                          <input
                            :class="{ 'is-danger': errors.phone }"
                            type="text"
                            v-model="form.phone"
                            class="form-control"
                          />
                        </div>
                        <span
                          v-if="errors.phone"
                          class="text-danger float-left small error-danger mb-2"
                          >{{ errors.phone }}</span
                        >
                      </div>
                      <div class="col-12 mt-2">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            for="role_id"
                            style="color: #616161; font-size: 14px"
                            ><b>Rol *</b>
                          </label>
                          <select
                            :class="{ 'is-danger': errors.action }"
                            class="form-control"
                            name="role_id"
                            id="role_id"
                            v-model="form.role_id"
                          >
                            <option value="null" disabled selected>
                              Seleccione un rol
                            </option>
                            <option value="4">Lubricador</option>
                            <option value="5">Motero</option>
                            <!-- <option value="7">Distribuidor</option> -->
                          </select>
                          <span
                            v-if="errors.action"
                            class="
                              text-danger
                              float-left
                              small
                              error-danger
                              mb-2
                            "
                            >{{ errors.action }}</span
                          >
                        </div>

                        <div
                          v-if="showD"
                          class="form-group"
                          style="margin-bottom: 0px"
                        >
                          <label
                            class="mt-3"
                            for="role_id"
                            style="color: #616161; font-size: 14px"
                            ><b>Distribuidor *</b>
                          </label>
                          <select
                            :class="{ 'is-danger': errors.status }"
                            class="form-control"
                            name="state"
                            id="state"
                            v-model="form.distributor_id"
                          >
                            <option value="null" selected
                              >Seleccione el distribuidor</option
                            >
                            <option 
                              v-for="data in listD" 
                              :key="data.id"
                              :value="data.id"
                            >
                              {{ data.name }}
                            </option>
                          </select>
                          <span
                            v-if="errors.action"
                            class="
                              text-danger
                              float-left
                              small
                              error-danger
                              mb-2
                            "
                            >{{ errors.action }}</span
                          >
                        </div>
                      </div>
                      <div class="col-12 mt-2">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            for="status_id"
                            style="color: #616161; font-size: 14px"
                            ><strong>Status *</strong>
                          </label>
                          <select
                            :class="{ 'is-danger': errors.action }"
                            class="form-control"
                            name="status_id"
                            id="status_id"
                            v-model="form.status_id"
                          >
                            <option value="null" disabled selected>
                              Seleccione una acción
                            </option>
                            <option value="1">Activo</option>
                            <option value="2">Inactivo</option>
                          </select>
                          <span
                            v-if="errors.action"
                            class="
                              text-danger
                              float-left
                              small
                              error-danger
                              mb-2
                            "
                            >{{ errors.action }}</span
                          >
                        </div>
                      </div>
                      <div class="col-12 mt-2">
                        <div class="form-group" style="text-align: left">
                          <label
                            class="ml-1"
                            style="color: #616161; font-size: 14px"
                            ><strong>Genero *</strong>
                          </label>
                          <div class="input-group mb-3">
                            <select
                              v-model="form.gender_id"
                              class="form-control"
                              :class="{ 'is-danger': errors.genderId }"
                              id="exampleFormControlSelect1"
                              placeholder="Ingresa aquí el género *"
                            >
                              <option value="4" disabled selected>
                                Ingresa aquí el género *
                              </option>
                              <option
                                v-for="(item, i) in listGenders"
                                :key="'td' + i"
                                :value="item.id"
                                class="color-option"
                              >
                                {{ item.name }}
                              </option>
                            </select>
                          </div>
                          <span
                            v-if="errors.genderId"
                            class="text-danger float-left small error-danger"
                            >{{ errors.genderId }}</span
                          >
                        </div>
                      </div>
                      <div class="col-12 mb-3">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            for="state"
                            style="color: #616161; font-size: 14px"
                            ><strong>Actualizar contraseña (Opcional)</strong>
                          </label>
                          <div class="input-group">
                            <input
                              v-model="form.newPassword"
                              @input="validarPassword"
                              :type="showPassword ? 'text' : 'password'"
                              class="form-control"
                              placeholder="Ingrese la nueva contraseña aquí"
                            />
                            <div @click="showPass" class="input-group-text" style="cursor:pointer;">
                              <span :class="showPassword ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"></span>
                            </div>
                          </div>
                          <p v-if="errors.newPassword" class="text-danger mt-2">
                            {{ errors.newPassword }}
                          </p>
                          <p v-else-if="is_valid" class="text-success mt-2">
                            Contraseña válida ✔️
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-10 col-md-5 col-lg-6 col-xl-6 col-sm-10 mt-3">
                <button
                  data-dismiss="modal"
                  type="button"
                  class="btn btn-secondary btn-sm btn-block button-login"
                >
                  Cancelar
                </button>
              </div>
              <div
                class="col-10 col-md-5 col-lg-6 col-xl-6 col-sm-10 mt-3 mb-3"
              >
                <button
                  @click="updateUser()"
                  type="button"
                  class="btn btn-danger btn-sm btn-block button-login"
                >
                  <template v-if="loading.changeDoc">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Actualizando...
                  </template>
                  <template v-else>Actualizar</template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal insertar usuarios masivo -->
    <div
      class="modal fade"
      id="modalUpdateM"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div v-if="loading.modal" class="row justify-content-center mt-5 pt-5">
        <div class="col-1 mt-5 pt-5">
          <div
            class="spinner-border text-danger"
            style="width: 4em; height: 4rem"
            role="status"
          ></div>
        </div>
      </div>

      <div
        v-if="!loading.modal"
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content modal-question">
          <div class="modal-body">
            <button
              type="button"
              data-dismiss="modal"
              aria-label="Close"
              class="close"
            >
              <i class="fa fa-times-circle text-danger" aria-hidden="true"></i>
            </button>
            <div class="mt-3 row justify-content-center">
              <div class="col-12 mb-3">
                <label style="color: #616161">
                  <strong>Insertar lista de usuarios</strong> </label
                ><br />
              </div>

              <div class="col-12 m-0 p-2" style="text-align: left">
                <label class="text-info"><strong>Ejemplo de csv</strong></label
                ><br /><img alt="Ejemplo csv" src="../../../../assets/ejemplo.png" width="450" />
              </div>
              <div class="col-12 m-0 p-2">
                <div class="row" style="text-align: left">
                  <div class="col-12 m-0 p-0">
                    <div class="row">
                      <div class="col-12">
                        <small class="text-info"
                          >El resgistro masivo aplica para usuario finales.
                          <strong> NO </strong> es posible el registro de
                          lubricadores por esta sección, este proceso debe
                          realizarlo un rol distribuidor.
                        </small>
                        <form ref="form" style="text-align: initial">
                          <label
                            class="mt-2"
                            for="image"
                            style="color: #616161; font-size: 14px"
                            ><strong>Adjuntar archivo csv *</strong></label
                          ><br />
                          <input
                            type="file"
                            multiple
                            accept="csv"
                            id="csv"
                            name="csv"
                            class="form-control-file mb-2 "
                            style="color: black"
                            @change="onfileSelected($event)"
                            :class="{ 'is-danger': errorsFile || errorsFile2 }"
                          />
                          <span
                            v-if="errorsFile2"
                            class="text-danger small error-danger"
                            >{{ errorsFile2 }}</span
                          >
                          <span
                            v-if="errorsFile"
                            class="text-danger small error-danger"
                            >{{ errorsFile }}</span
                          ><br />
                        </form>
                      </div>

                      <div class="col-12 mt-2">
                        <div class="form-group" style="margin-bottom: 0px">
                          <label
                            class="ml-1"
                            for="state"
                            style="color: #616161; font-size: 14px"
                            ><strong>Origen *</strong>
                          </label>
                          <input
                            v-model="formA.field"
                            type="text"
                            class="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Escribe el origen del listado de usuarios"
                            autocomplete="off"
                          />
                        </div>
                      </div>

                      <div
                        class="col-10 col-md-5 col-lg-6 col-xl-6 col-sm-10 mt-3"
                      >
                        <button
                          data-dismiss="modal"
                          type="button"
                          class="
                            btn btn-secondary btn-sm btn-block
                            button-login
                          "
                        >
                          Cancelar
                        </button>
                      </div>
                      <div
                        class="
                          col-10 col-md-5 col-lg-6 col-xl-6 col-sm-10
                          mt-3
                          mb-3
                        "
                      >
                        <button
                          @click="saveMasiveUser()"
                          type="button"
                          class="btn btn-danger btn-sm btn-block button-login"
                        >
                          <template v-if="loading.changeDoc">
                            <span
                              class="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Cargando...
                          </template>
                          <template v-else>Adjuntar</template>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import vPagination from "vue-plain-pagination";
import axios from 'axios';

export default {
  components: { vPagination },
  data() {
    return {
      errorsFile: false,
      errorsFile2: false,
      totalPages: 4,
      bootstrapPaginationClasses: {
        ul: "pagination",
        li: "page-item",
        liActive: "active",
        liDisable: "disabled",
        button: "page-link",
      },
      totaItems: null,
      currentPage: 1,
      listD: [],
      listGenders: [],
      listTypeDocuments: [],
      listCities: [],
      listDocuments: [],
      distri: null,
      items: [],
      searchN: "Buscar usuarios por cédula o por correo",
      numC: 0,
      currenNumC: 0,
      form: {
        id: 0,
        name: "",
        email: "",
        last_name: "",
        address: "",
        document_number: "",
        phone: "",
        state_id: "",
        city_id: "",
        role_id: "",
        status_id: "",
        document_type_id: "",
        newPassword: ""
      },
      showPassword: false,
      currentFrom: {},
      formA: {
        field: null,
        action: null,
        file: null,
      },
      errors: {
        id: 0,
        name: false,
        email: false,
        last_name: false,
        address: false,
        document_number: false,
        phone: false,
        newPassword: false
      },
      is_valid: false,
      loading: {
        history: false,
        changeDoc: false,
        modal: false,
      },
      showD: false,
      paginate: ["items"],
      page: 1,
      isWon: false,
      validateAction: false, // valida que debe cpnsumir al momento de cambiar página en el watch
    };
  },
  methods: {
    irR() {
      this.$router.push({ name: "adminReports" });
    },
    getDistribuidor() {
      axios
        .get("superAdmin/all/distributors")
        .then((res) => {
          if (res.data.cod == 0) {
            this.listD = res.data.data;
          }
        })
        .catch((error) => {});
    },
    modalConfirmar() {
      if (this.formA.file == null) {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops..",
          text: "Los campos marcados con (*) son obligatorios",
        });
        return false;
      }
      this.$swal({
        title: "Cofirmación de actualización",
        text: "¿Está seguro de ?",
        icon: "info",
        showCancelButton: true,
        cancelButtonText: "cancelar",
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#1da5df",
        confirmButtonText: "Actualizar",
      }).then((result) => {
        if (result.value) {
          this.saveMasiveUser();
        }
      });
    },
    saveMasiveUser() {
      const data = new FormData();
      if (this.formA.field == null || this.formA.file == null) {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops..",
          text: "Los campos marcados con (*) son obligatorios",
        });
        return false;
      }
      data.append("file", this.formA.file);
      data.append("origin", this.formA.field);
      this.loading.modal = true;
      axios
        .post("admin/users/csv/add", data, { timeout: 25000 })
        .then((res) => {
          if (res.data.cod == 0) {
            this.formA.file = null;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
          }
          this.loading.modal = false;
          $("#modalUpdateM").modal("hide");
        })
        .catch((error) => {
          this.loading.modal = false;
          $("#modalUpdateM").modal("hide");
          if (error.code == "ECONNABORTED") {
            this.formA.file = null;
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "info",
              title: "Información",
              text:
                "Estamos trabajando en la actualización de los datos, por favor diríjase a la sección de reportes.",
            });
          } else {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops..",
              text: error.response.data.message,
            });
          }
        });
    },
    modalM() {
      $("#modalUpdateM").modal("show");
    },
    onfileSelected(event) {
      let app = this;
      var fileSize = null;
      var extension = null;
      var url = null;
      fileSize = event.target.files[0].size;
      extension = event.target.files[0].name.split(".");
      if (fileSize > 1000000) {
        this.errorsFile = "El archivo no debe superar 1MB. ";
        return false;
      }
      if (extension[1] != "csv") {
        this.errorsFile2 = " La extensión es inválida. ";
        return false;
      } else {
        this.errorsFile = false;
        this.errorsFile2 = false;
        app.formA.file = event.target.files[0];
      }
    },
    getData() {
      this.items = [];
      this.loading.history = true;
      this.validateAction = false;
      axios
        .get("superAdmin/users/list?page=" + this.currentPage)
        .then((res) => {
          if (res.data.cod == 0) {
            // console.log(JSON.stringify(res));
            this.items = res.data.data.data;
            this.totaItems = res.data.data.total;
            this.totalPages = res.data.data.last_page;
          }
          this.loading.history = false;
        })
        .catch((error) => {
          this.loading.history = false;
        });
    },
    update(data) {
      this.form = data;
      this.currentFrom.address = data.address;
      this.currentFrom.city_id = data.city_id;
      this.currentFrom.distributor_id = data.distributor_id;
      this.currentFrom.document_number = data.document_number;
      this.currentFrom.document_type_id = data.document_type_id;
      this.currentFrom.email = data.email;
      this.currentFrom.gender_id = data.gender_id;
      this.currentFrom.last_name = data.last_name;
      this.currentFrom.name = data.name;
      this.currentFrom.phone = data.phone;
      this.currentFrom.role_id = data.role_id;
      this.currentFrom.state_id = data.state_id;
      this.currentFrom.status_id = data.status_id;

      console.log(this.form);
      $("#modalUpdateL").modal("show");
    },
    search() {
      this.items = [];
      this.loading.history = true;
      var data = {
        documentOrEmail: this.searchN,
      };
      if (this.searchN == null || this.searchN == "") {
        this.getData();
        return false;
      }
      this.validateAction = true;
      axios
        .post("superAdmin/all/users?page=" + this.currentPage, data)
        .then((res) => {
          if (res.data.cod == 0) {
            this.items = res.data.data.data;
            this.totaItems = res.data.data.total;
            this.totalPages = res.data.data.last_page;
          }
          this.loading.history = false;
        })
        .catch((error) => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    validform() {
      if (!this.form.name) {
        this.errors.name = "El nombre del usuario es requerido.";
      }
      if (!this.form.document_number) {
        this.errors.document_number =
          "El número del documento del usuario es requerido.";
      }
      if (!this.form.email) {
        this.errors.email = "El email del usuario es requerido.";
      }
      if (
        !this.errors.name &&
        !this.errors.document_number &&
        !this.errors.email
      ) {
        return true;
      }

      return false;
    },
    updateUser() {
      // console.log(this.form)
      if (
        this.form.name == null ||
        this.form.name == "" ||
        this.form.email == null ||
        this.form.email == "" ||
        this.form.document_number == null ||
        this.form.document_number == "" ||
        this.form.city_id == null ||
        this.form.state_id == null
      ) {
        // console.log("VALIDAR")
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops..",
          text: "Los campos marcados con (*) son obligatorios",
        });
        return false;
      }

      var data = {
        name: this.form.name,
        email: this.form.email,
        document_number: this.form.document_number,
        city_id: this.form.city_id,
        state_id: this.form.state_id,
      };

      if (this.form.last_name != this.currentFrom.last_name) {
        data.last_name = this.form.last_name;
      }
      if (this.form.document_type_id != this.currentFrom.document_type_id) {
        data.document_type_id = this.form.document_type_id;
      }
      if (this.form.address != this.currentFrom.address) {
        data.address = this.form.address;
      }
      if (this.form.phone != this.currentFrom.phone) {
        data.phone = this.form.phone;
      }
      if (this.form.role_id != this.currentFrom.role_id) {
        data.role_id = this.form.role_id;
      }
      if (this.showD) {
        if (this.form.distributor_id != null) {
          data.distribuidor_id = this.form.distributor_id;
        } else {
          this.$swal({
            icon: "info",
            title: "Oops..",
            text: "El distribuidor es requerido",
            confirmButtonColor: "#dc3545"
          });
          return false;
        }
      }
      if (this.form.status_id != this.currentFrom.status_id) {
        data.status_id = this.form.status_id;
      }
      if (this.form.gender_id != this.currentFrom.gender_id) {
        data.gender_id = this.form.gender_id;
      }
      if (this.form.newPassword != "") {
        data.newPassword = this.form.newPassword;
      }
      this.loading.changeDoc = true;

      axios
        .put("superAdmin/users/update/" + this.form.id, data)
        .then((res) => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
          }
          this.getData();
          this.loading.changeDoc = false;
          $("#modalUpdateL").modal("hide");
          this.showPassword = false;
          this.is_valid = false;
        })
        .catch((error) => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Error",
            text: error.response.data.message,
          });
        });
    },
    pageChange(toPage) {
      console.log("ENTROO");
      this.page = toPage;
    },
    getGenders() {
      axios
        .get("api/getGenders")
        .then((res) => {
          this.listGenders = res.data.data;
        })
        .catch((error) => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    getListStates() {
      var app = this;
      axios
        .get("api/getStates")
        .then(function(res) {
          app.listDocuments = res.data.states;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getCities(stateId) {
      var app = this;
      var data = {
        stateId: stateId,
      };
      axios
        .post("api/showCity", data)
        .then(function(res) {
          app.listCities = res.data.cities;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getTypeDocuments() {
      var app = this;
      axios
        .get("api/documentTypeController")
        .then(function(res) {
          app.listTypeDocuments = res.data.TypeDocument;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    clearInput() {
      this.searchN = "";
    },
    GoCodesStatus(){
      this.$router.push({ name: "registeredCodesByDay" });
    },
    GoHistoryPoints(){
      this.$router.push({ name: "historyPoints" });
    },
    showPass(){
      this.showPassword = !this.showPassword;
    },
    validarPassword() {
      const newVal = this.form.newPassword;
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])\S{8,16}$/;

      if (newVal === '') {
        this.errors.newPassword = false;
        this.is_valid = false;
      } else if (!regex.test(newVal)) {
        this.errors.newPassword = "La contraseña debe tener al menos 8 caracteres, una mayúscula, una minúscula, un número y un carácter especial.";
        this.is_valid = false;
      } else {
        this.errors.newPassword = false;
        this.is_valid = true;
      }
    },
  },
  mounted() {
    this.getGenders();
    this.getTypeDocuments();
    this.getListStates();
    this.getData();
    this.pageChange(1);
    this.getDistribuidor();
  },
  watch: {
    currentPage: function(newL) {
      if (this.validateAction) {
        this.search();
      } else {
        this.getData();
      }
    },
    searchN: function(newN) {},
    "form.name": function(newV) {
      if (!newV) {
        this.errors.name = "El nombre del usuario es requerido.";
      } else {
        this.errors.name = false;
      }
    },
    "form.state_id": function(n) {
      this.getCities(n);
      if (n) {
      }
    },
    "form.email": function(newV) {
      if (!newV) {
        this.errors.email = "El email del usuario es requerido.";
      } else {
        this.errors.email = false;
      }
    },
    "form.document_number": function(newV) {
      if (!newV) {
        this.errors.document_number =
          "El número del documento del usuario es requerido.";
      } else {
        this.errors.document_number = false;
      }
    },
    "form.role_id": function(newR) {
      if (newR == 4) {
        this.showD = true;
      } else {
        this.form.distributor_id = null;
        this.showD = false;
      }
    }
  },
};
</script>

<style>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.div-button {
  margin-top: 50px;
  text-align: left;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.modal-title {
  color: black;
  font-weight: bold;
}
.modal-question {
  border: solid 3px;
  border-color: #dc3545;
  border-radius: 15px;
}
label {
  color: black;
  margin-right: 4px;
}
.img-banner {
  display: block;
  width: 25%;
  text-align: center;
  margin: auto;
}
td {
  text-align: center;
  vertical-align: -webkit-baseline-middle;
  cursor: all-scroll;
}
.table-container {
  overflow: auto;
}
h5 {
  margin-bottom: 10px !important;
}
.commentary {
  text-align: left;
  color: #1da5df;
  font-size: 13px;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.page-link {
  border-radius: 100px;
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #dc3545;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  color: #000;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>
